import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../Pages/Dashboard';
import BossesList from '../Pages/BossesList';
import EmployeesList from '../Pages/EmployeesList';
import PendingRequests from '../Pages/PendingRequests';
import Login from '../Pages/Login';
import ProtectedRoute from '../utils/ProtectedRoute';
import Recommendations from '../Pages/Recommendations';
import TermsOfService from '../Pages/TermsOfService';
import PrivacyPolicy from '../Pages/PrivacyPolicy';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path='/terms' element={<TermsOfService />} /> 
      <Route path='/privacy' element={<PrivacyPolicy />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bosses"
        element={
          <ProtectedRoute>
            <BossesList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/employees"
        element={
          <ProtectedRoute>
            <EmployeesList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pending_requests"
        element={
          <ProtectedRoute>
            <PendingRequests />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recommendations/:bossId"
        element={
            <Recommendations />
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;